// @flow
import React from 'react'; // eslint-disable-line no-unused-vars
import { connect } from 'react-redux';
import {Fab} from '@mui/material';

import {
    setCrumbPath,
    fetchIncidents,
    fetchIncidentTypes,
    fetchIncidentCause,
    saveIncident,
    deleteIncident,
    seenIncident,
    setViewkey,
    filterPeriodType,
    filterPeriodYear,
    filterPeriodMonth,
    filterPeriodWeek,
    filterPeriodFrom,
    filterPeriodTill,
} from '../../actions';
import AppModule from '../AppModule';
import EnhancedTable from '../EnhancedTable';
import moment from '../../lib/moment';
import 'moment/min/locales';
import { inProgress } from '../../selectors';
import TableActionHeader from '../TableActionHeader/TableActionHeader';
import WarningIcon from '@mui/icons-material/Warning';
import {
    Button,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Drawer,
    FormControl,
    IconButton,
    Input,
    InputLabel,
    ListItemText,
    Menu,
    MenuItem,
    Switch,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TitleDescription from '../TitleDescription';
import Viewer from 'react-viewer';
import Select from '@mui/material/Select';
import ConfirmDialog from '../ConfirmDialog';
import PeriodFilterBlock from '../FilterBlocks/PeriodFilterBlock';
import FilterHeader from '../FilterHeader';
import $ from 'jquery';
import { bindActionCreators } from 'redux';
import { getCurrentFilterSet } from '../../reducers/filterReducer';
import DownloadIcon from '@mui/icons-material/GetApp';
import DescIcon from '@mui/icons-material/Description';
import {fetchCSV, fetchPDF} from '../../lib/api';
import { percentColors1 } from '../../lib/utils';
import { compose } from 'recompose';
import { withTranslation } from 'react-i18next';
import SimpleImageInput from '../SimpleImageInput';
import DeleteIcon from '@mui/icons-material/Delete';
import i18n from 'i18next';
import classes from './Incident.module.scss';
import colors from '../../lib/themes/theme.scss';

moment.locale(i18n.t('LOCALE'));


type Props = {
    loading: boolean,
    incidents: Array<any>,
    permissions: any,
    setCrumbPath: () => void,
    roles: Array<any>,
    fetchIncidents: () => mixed,
    fetchIncidentTypes: () => mixed,
    fetchIncidentCause: () => mixed,
    saveIncident: () => mixed,
    deleteIncident: () => mixed,
    seenIncident: () => mixed,
    incidentcause: Array<any>,
    incidenttype: Array<any>,
};

type State = {
    columns: Array<any>,
    actions: Array<{
        id: string,
        label: string,
        isVisible?: (id: any) => boolean,
    }>,
    searchtext: string,
    incidentOpen: boolean,
    incident: Array<any>,
    imageVisible: boolean,
    editMode: boolean,
    showDeleteDialog: boolean,
    incidentToDelete: Array<any>,
    anchorEl?: any,
    openType: boolean,
    typeFilter: any,
    openCause: boolean,
    causeFilter: any,
    openEmployees: boolean,
    employeesFilter: any,
    openMaatregel: boolean,
    maatregelFilter: any,
    exportOpen: boolean,
    situatieFilter: any,
    openSituatie: boolean,
    openWarning: boolean,
    showResolveDialog: boolean,
    incidentToResolve: any,
    incidentToResolveComment: string,
    incidentToResolveSwitch: boolean,

};

const viewkey: string = 'INCIDENT_VIEW';


const mapStateToProps = (store) => {
    let filters = getCurrentFilterSet(store.filters);

    return {
        loading: !inProgress(store),
        incidents: store.entities.incidents,
        incidenttype: store.entities.incidenttype,
        incidentcause: store.entities.incidentcause,
        employees: store.entities.employees,
        periodType: filters.periodType,
        periodYear: filters.periodYear,
        periodMonth: filters.periodMonth,
        periodWeek: filters.periodWeek,
        periodFrom: filters.periodFrom,
        periodTill: filters.periodTill,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        filterPeriodType: bindActionCreators(filterPeriodType, dispatch),
        filterPeriodYear: bindActionCreators(filterPeriodYear, dispatch),
        filterPeriodMonth: bindActionCreators(filterPeriodMonth, dispatch),
        filterPeriodWeek: bindActionCreators(filterPeriodWeek, dispatch),
        filterPeriodFrom: bindActionCreators(filterPeriodFrom, dispatch),
        filterPeriodTill: bindActionCreators(filterPeriodTill, dispatch),
        fetchIncidents: () => {
            dispatch(fetchIncidents());
        },
        fetchIncidentTypes: () => {
            dispatch(fetchIncidentTypes());
        },
        fetchIncidentCause: () => {
            dispatch(fetchIncidentCause());
        },
        saveIncident: (data) => {
            dispatch(saveIncident(data));
        },
        seenIncident: (data) => {
            dispatch(seenIncident(data));
        },
        deleteIncident: (data) => {
            dispatch(deleteIncident(data));
        },
        setCrumbPath: () => {
            dispatch(setCrumbPath({ title: 'Registratiemeldingen' }));
        },
        setViewkey: () => {
            dispatch(setViewkey(viewkey));
        },
    };
};

let users = [];

class Incidents extends React.Component<Props, State> {
    props: Props;
    state: State = {
        columns: [],
        actions: [],
        searchtext: '',
        incidentOpen: false,
        imageVisible: false,
        activePhotoId: undefined,
        editMode: false,
        showDeleteDialog: false,
        anchorEl: 0,
        openType: false,
        typeFilter: 0,
        openCause: false,
        causeFilter: 0,
        openEmployees: false,
        employeesFilter: 0,
        openMaatregel: false,
        maatregelFilter: 0,
        exportOpen: false,
        situatieFilter: 0,
        openSituatie: false,
        openWarning: false,
        showResolveDialog: false,
        incidentToResolveComment: null,
        incidentToResolveSwitch: null,

    };


    componentDidMount() {
        moment.locale(i18n.t('LOCALE'));
        this.setState({
            columns: [
                { id: 'date', label: 'Date', size: '10%' },
                { id: 'type', label: 'Type of report', size: '11%' },
                { id: 'title', label: 'Description', size: '14%' },
                { id: 'from', label: 'Reported by', size: '11%' },
                { id: 'cause', label: 'Type of cause', size: '8%' },
                { id: 'maatregel', label: 'Measure', size: '8%' },
                { id: 'attachments', label: 'Attachments', size: '8%' },
                { id: 'situation', label: 'Situation', size: '8%' },
                { id: 'kamResolved', label: 'Resolved', size: '8%' },
            ],
        });
    }

    handleAction = (event, action) => {
        if (action.id === 'edit') {
            // window.$crisp.push(['do', 'chat:hide']);

            this.setState({
                editMode: true,
                incidentOpen: true,
                incident: this.props.incidents.byId[action.rowId],
            });
        } else if (action.id === 'delete') {
            // window.$crisp.push(['do', 'chat:hide']);

            this.setState({
                incidentToDelete: this.props.incidents.byId[action.rowId],
                incident: this.props.incidents.byId[action.rowId],
                showDeleteDialog: true,
            });
        } else if (action.id === 'markResolved') {
            // window.$crisp.push(['do', 'chat:hide']);
            let incident = this.props.incidents.byId[action.rowId];
            this.setState({
                incidentToResolve: incident,
                incidentToResolveComment: incident.kamComment,
                incidentToResolveSwitch: incident.kamResolved,
                showResolveDialog: true,
            });
        } else if (action.id = 'getPDF') {
            console.log('getPDF');
            this.downloadPdf(this.props.incidents.byId[action.rowId])

        }
    };

    editKamStatus = (key) => (event) => {
        if (key === 'kamComment') {
            this.setState({
                incidentToResolveComment: event.target.value
            });
        } else if (key === 'kamSwitch') {
            this.setState({
                incidentToResolveSwitch: !this.state.incidentToResolveSwitch
            });

        } else if (key === 'kamSave') {
            // Update incident
            let incident = this.props.incidents.byId[this.state.incidentToResolve.id];
            incident.kamComment =  this.state.incidentToResolveComment;
            incident.kamResolved =  this.state.incidentToResolveSwitch;

            this.props.saveIncident(incident);

            this.setState({
                showResolveDialog: false
            });
        }
    }


    handleSearch = (searchtext) => {
        this.setState({
            searchtext: searchtext,
        });
    };

    mapIncidentToRow = (incident) => {
        const { t } = this.props;
        moment.locale(i18n.t('LOCALE'));

        return {
            ...incident,
            date: !incident.date ? (
                '-'
            ) : incident.isnew ? (
                <div>

                    <div
                        style={{
                            width: '8px',
                            height: '8px',
                            backgroundColor: '#0076FF',
                            borderRadius: '24px',
                            float: 'left',
                            marginTop: '4px',
                        }}
                    ></div>
                    <div style={{ float: 'left', marginLeft: '8px' }}>
                        {moment(incident.date).format('L HH:mm')}
                    </div>
                </div>
            ) : (
                <div>
                    <div
                        style={{
                            width: '8px',
                            height: '8px',
                            float: 'left',
                            marginTop: '4px',
                        }}
                    ></div>
                    <div style={{ float: 'left', marginLeft: '8px' }}>
                        {moment(incident.date).format('L HH:mm')}
                    </div>
                </div>
            ),
            type:
                incident.type && this.props.incidenttype
                    ? t(
                          this.props.incidenttype.byId[incident.type].locKey ||
                              this.props.incidenttype.byId[incident.type].name
                      )
                    : '-',
            from: incident.anonymous ? t("anonymous") : incident.user.fullname,
            cause:
                incident.cause && this.props.incidentcause
                    ? t(
                          this.props.incidentcause.byId[incident.cause]
                              .locKey ||
                              this.props.incidentcause.byId[incident.cause].name
                      )
                    : '-',
            title: incident.remark.text ? incident.remark.text : '-',
            attachments: incident.remark.photos
                ? incident.remark.photos.length
                : '0',
            maatregel:
                incident.maatregelen && incident.maatregelen.length > 0
                    ? t('Yes')
                    : t('No'),
            situation: incident.remark.unsafe ? (
                <div
                    className={'border-text'}
                    style={{
                        backgroundColor: getColorForPercentage(0),
                        borderColor: getColorForPercentage(0),
                        width: '70px',
                        fontWeight: '300',
                    }}
                >
                    <span>
                        <WarningIcon
                            style={{
                                width: '14px',
                                height: '14px',
                                position: 'relative',
                                top: '2px',
                                marginRight: '5px',
                            }}
                        />
                        {t('Unsafe')}
                    </span>
                </div>
            ) : (
                ''
            ),
            kamResolved:
                (<div title={incident.kamComment}>
                    {incident.kamResolved ? t('Yes') : t('No')}
                </div>),
        };
    };

    onRowClick = (row, event) => {
        // window.$crisp.push(['do', 'chat:hide']);

        this.setState({
            incidentOpen: true,
            incident: this.props.incidents.byId[row.id],
        });

        if (this.props.incidents.byId[row.id].isnew) {
            this.props.seenIncident(this.props.incidents.byId[row.id]);
        }
    };

    handleRequestClose = () => {
        const newState = Object.assign({}, this.state, {
            openType: false,
            openCause: false,
            openEmployees: false,
            openMaatregel: false,
            openSituatie: false,
        });
        this.setState(newState);
    };

    handleTouchTap0 = (event: Event) => {
        // This prevents ghost click.
        event.preventDefault();

        const newState = Object.assign({}, this.state, {
            openType: true,
            anchorEl: event.currentTarget,
        });

        this.setState(newState);
        setTimeout(() => {
            $('ul.tabs').tabs();
        }, 100);
    };

    handleTouchTap1 = (event: Event) => {
        // This prevents ghost click.
        event.preventDefault();

        const newState = Object.assign({}, this.state, {
            openEmployees: true,
            anchorEl: event.currentTarget,
        });

        this.setState(newState);
        setTimeout(() => {
            $('ul.tabs').tabs();
        }, 100);
    };

    handleTouchTap2 = (event: Event) => {
        // This prevents ghost click.
        event.preventDefault();

        const newState = Object.assign({}, this.state, {
            openCause: true,
            anchorEl: event.currentTarget,
        });

        this.setState(newState);
        setTimeout(() => {
            $('ul.tabs').tabs();
        }, 100);
    };

    handleTouchTap3 = (event: Event) => {
        // This prevents ghost click.
        event.preventDefault();

        const newState = Object.assign({}, this.state, {
            openMaatregel: true,
            anchorEl: event.currentTarget,
        });

        this.setState(newState);
        setTimeout(() => {
            $('ul.tabs').tabs();
        }, 100);
    };

    handleTouchTap4 = (event: Event) => {
        // This prevents ghost click.
        event.preventDefault();

        const newState = Object.assign({}, this.state, {
            openSituatie: true,
            anchorEl: event.currentTarget,
        });

        this.setState(newState);
        setTimeout(() => {
            $('ul.tabs').tabs();
        }, 100);
    };

    handleTypeFilterChange = (event) => {
        this.handleRequestClose();
        this.setState({ typeFilter: event.target.value });
    };

    handleCauseFilterChange = (event) => {
        this.handleRequestClose();
        this.setState({ causeFilter: event.target.value });
    };

    handleEmployeesFilterChange = (event) => {
        this.handleRequestClose();
        this.setState({ employeesFilter: event.target.value });
    };

    handleMaatregelFilterChange = (event) => {
        this.handleRequestClose();
        this.setState({ maatregelFilter: event.target.value });
    };

    handleSituatieFilterChange = (event) => {
        this.handleRequestClose();
        this.setState({ situatieFilter: event.target.value });
    };

    getFilterBar = () => {
        const { t } = this.props;

        return (
            <div className="filterbar">
                <PeriodFilterBlock />
                <div style={{ marginLeft: '20px' }}>
                    <span onClick={this.handleTouchTap0}>
                        <FilterHeader
                            filterTitle={t('Type of report')}
                            filterValue={
                                !this.props.incidenttype ||
                                this.state.typeFilter === 0
                                    ? t('Everything')
                                    : this.props.incidenttype.byId[
                                          this.state.typeFilter
                                      ].name
                            }
                        />
                    </span>
                </div>

                <Menu
                    open={this.state ? this.state.openType : false}
                    onClose={this.handleRequestClose}
                    value={this.state.typeFilter}
                    anchorEl={this.state ? this.state.anchorEl : 0}
                >
                    <MenuItem onClick={this.handleTypeFilterChange} value={0} key={0} selected={0 === this.state.typeFilter}>
                        Alles
                    </MenuItem>
                    {this.props.incidenttype &&
                        this.props.incidenttype.allIds.map((id) => {
                            return (
                                <MenuItem
                                    onClick={this.handleTypeFilterChange}
                                    value={id}
                                    key={id}
                                    selected={id === this.state.typeFilter.toString()}
                                >
                                    {t(`${this.props.incidenttype.byId[id].locKey || this.props.incidenttype.byId[id].name}`)}
                                </MenuItem>
                            );
                        })}
                </Menu>

                <div>
                    <span onClick={this.handleTouchTap1}>
                        <FilterHeader
                            filterTitle={t('Detector')}
                            filterValue={
                                !this.props.employees ||
                                this.state.employeesFilter === 0
                                    ? t('Everything')
                                    : this.props.employees.byId[
                                          this.state.employeesFilter
                                      ].fullname
                            }
                        />
                    </span>
                </div>

                <Menu
                    open={this.state ? this.state.openEmployees : false}
                    onClose={this.handleRequestClose}
                    value={this.state.employeesFilter}
                    anchorEl={this.state ? this.state.anchorEl : 0}
                >
                    <MenuItem
                        onClick={this.handleEmployeesFilterChange}
                        value={0}
                        key={0}
                        selected={0 === this.state.employeesFilter}
                    >
                        {t('Everything')}
                    </MenuItem>
                    {this.props.employees &&
                        this.props.employees.allIds.length > 0 &&
                        users &&
                        users.map((id) => {
                            return this.props.employees.byId[id] ? (
                                <MenuItem
                                    onClick={this.handleEmployeesFilterChange}
                                    value={id}
                                    key={id}
                                    selected={id === this.state.employeesFilter}
                                >
                                    {this.props.employees.byId[id].fullname}
                                </MenuItem>
                            ) : null;
                        })}
                </Menu>

                <div>
                    <span onClick={this.handleTouchTap2}>
                        <FilterHeader
                            filterTitle={t('Type of cause')}
                            filterValue={
                                !this.props.incidentcause ||
                                this.state.causeFilter === 0
                                    ? t('Everything')
                                    : t(
                                          this.props.incidentcause.byId[
                                              this.state.causeFilter
                                          ].locKey ||
                                              this.props.incidentcause.byId[
                                                  this.state.causeFilter
                                              ].name
                                      )
                            }
                        />
                    </span>
                </div>

                <Menu
                    open={this.state ? this.state.openCause : false}
                    onClose={this.handleRequestClose}
                    value={this.state.causeFilter}
                    anchorEl={this.state ? this.state.anchorEl : 0}
                >
                    <MenuItem onClick={this.handleCauseFilterChange} value={0} key={0} selected={0 === this.state.causeFilter}>
                        {t('Everything')}
                    </MenuItem>
                    {this.props.incidentcause &&
                        this.props.incidentcause.allIds.map((id) => {
                            return (
                                <MenuItem
                                    onClick={this.handleCauseFilterChange}
                                    value={id}
                                    key={id}
                                    selected={id === this.state.causeFilter.toString()}
                                >
                                    {t(
                                        `${
                                            this.props.incidentcause.byId[id]
                                                .locKey ||
                                            this.props.incidentcause.byId[id]
                                                .name
                                        }`
                                    )}
                                </MenuItem>
                            );
                        })}
                </Menu>

                <div>
                    <span onClick={this.handleTouchTap3}>
                        <FilterHeader
                            filterTitle={t('Measure')}
                            filterValue={
                                this.state.maatregelFilter === 0
                                    ? t('Everything')
                                    : this.state.maatregelFilter === 1
                                    ? t('Yes')
                                    : t('No')
                            }
                        />
                    </span>
                </div>

                <Menu
                    open={this.state ? this.state.openMaatregel : false}
                    onClose={this.handleRequestClose}
                    value={this.state.maatregelFilter}
                    anchorEl={this.state ? this.state.anchorEl : 0}
                >
                    <MenuItem
                        onClick={this.handleMaatregelFilterChange}
                        value={0}
                        selected={0 === this.state.maatregelFilter}
                    >
                        {t('Everything')}
                    </MenuItem>
                    <MenuItem
                        onClick={this.handleMaatregelFilterChange}
                        value={1}
                        selected={1 === this.state.maatregelFilter}

                        style={{ width: '120px' }}
                    >
                        {t('Yes')}
                    </MenuItem>
                    <MenuItem
                        onClick={this.handleMaatregelFilterChange}
                        value={2}
                        selected={2 === this.state.maatregelFilter}

                    >
                        {t('No')}
                    </MenuItem>
                </Menu>

                <div>
                    <span onClick={this.handleTouchTap4}>
                        <FilterHeader
                            filterTitle={t('Situation')}
                            filterValue={
                                this.state.situatieFilter === 0
                                    ? t('Everything')
                                    : this.state.situatieFilter === 1
                                    ? t('Is save')
                                    : t('Unsafe')
                            }
                        />
                    </span>
                </div>

                <Menu
                    open={this.state ? this.state.openSituatie : false}
                    onClose={this.handleRequestClose}
                    value={this.state.situatieFilter}
                    anchorEl={this.state ? this.state.anchorEl : 0}
                >
                    <MenuItem
                        onClick={this.handleSituatieFilterChange}
                        value={0}
                        selected={0 === this.state.situatieFilter}
                    >
                        {t('Everything')}
                    </MenuItem>
                    <MenuItem
                        onClick={this.handleSituatieFilterChange}
                        value={1}
                        selected={1 === this.state.situatieFilter}
                        style={{ width: '120px' }}
                    >
                        {t('Is save')}
                    </MenuItem>
                    <MenuItem
                        onClick={this.handleSituatieFilterChange}
                        value={2}
                        selected={2 === this.state.situatieFilter}
                    >
                        {t('Unsafe')}
                    </MenuItem>
                </Menu>
            </div>
        );
    };

    incidentSorter = () => {
        return {
            deployed: (a, b) => {
                a = a.date;
                b = b.date;

                if (a == null) {
                    return -1;
                }
                if (b == null) {
                    return 1;
                }

                a = moment(a).valueOf();
                b = moment(b).valueOf();

                if (a > b) {
                    return 1;
                } else if (a < b) {
                    return -1;
                } else {
                    return 0;
                }
            },
            title: (a, b) => {
                a = a.remark.text.toLowerCase();
                b = b.remark.text.toLowerCase();

                if (a > b) {
                    return 1;
                } else if (a < b) {
                    return -1;
                } else {
                    return 0;
                }
            },
            from: (a, b) => {
                a = a.user.fullname.toLowerCase();
                b = b.user.fullname.toLowerCase();

                if (a > b) {
                    return 1;
                } else if (a < b) {
                    return -1;
                } else {
                    return 0;
                }
            },
            attachments: (a, b) => {
                a = a.remark.photos.length;
                b = b.remark.photos.length;

                if (a > b) {
                    return 1;
                } else if (a < b) {
                    return -1;
                } else {
                    return 0;
                }
            },
            situation: (a, b) => {
                a = a.remark.unsafe;
                b = b.remark.unsafe;

                if (a === true) {
                    return 1;
                } else if (b === true) {
                    return -1;
                } else {
                    return 0;
                }
            },
        };
    };

    toggleDrawer = () => {
        // window.$crisp.push(['do', 'chat:show']);
        this.setState({
            incidentOpen: false,
            editMode: false,
        });
    };

    editMode = () => {
        this.setState({
            editMode: true,
        });
    };

    deleteIncident = () => {
        this.props.deleteIncident(this.state.incident);

        // window.$crisp.push(['do', 'chat:show']);
        this.setState({
            incidentOpen: false,
            editMode: false,
        });
    };

    deleteIncidentDialog = () => {
        this.setState({
            incidentToDelete: this.state.incident,
            showDeleteDialog: true,
        });
    };

    hideDeleteDialog = () => {
        this.setState({
            showDeleteDialog: false,
        });
    };

    save = () => {
        if (
            this.state.incident.remark.text.length > 0 &&
            this.state.incident.type !== null &&
            this.state.incident.cause !== null &&
            this.state.incident.cause !== undefined &&
            this.state.incident.cause_comment.length > 0
        ) {
            this.props.saveIncident(this.state.incident);
            this.setState({
                editMode: false,
            });
        } else {
            this.setState({
                openWarning: true,
            });
        }
    };

    cancelEditMode = () => {
        this.setState({
            editMode: false,
            incident: this.props.incidents.byId[this.state.incident.id],
        });
    };

    toggleExport = () => {
        if (this.state && this.state.exportOpen) {
            this.setState({
                exportOpen: false,
            });
        } else {
            this.setState({
                exportOpen: true,
            });
        }
    };

    downloadPdf = (incident) => {
        console.log('downloadPdf: for: ', incident);


        fetchPDF({
            platform: 'VV',
            customer: 'VV',
            template: 'INCIDENT',
            options: {},
            data: [],
            info: {
                incident: incident,
            },
        })
            .then((res) => {
                var encodedUri = window.URL.createObjectURL(res.body);

                var link = document.createElement('a');
                link.setAttribute('href', encodedUri);
                link.setAttribute(
                    'download',
                    incident.date + '.pdf'
                );
                document.body.appendChild(link);
                link.click(); //
            })
            .catch((err) => console.log(err));

    };

    // Download a CSV with all rows that match the selected period
    downloadCsv = () => {
        const { t } = this.props;
        let incidents = [];

        this.props.incidents &&
            this.props.incidents.allIds &&
            this.props.incidents.allIds.forEach((id) => {
                incidents.push(this.props.incidents.byId[id]);

                if (!users.includes(this.props.incidents.byId[id].user.id)) {
                    users.push(this.props.incidents.byId[id].user.id);
                }
            });

        incidents = incidents
            .filter((i) =>
                this.state.typeFilter && this.state.typeFilter !== 0
                    ? i.type === this.state.typeFilter.toString()
                    : true
            )
            .filter((i) =>
                this.state.employeesFilter && this.state.employeesFilter !== 0
                    ? i.user.id === this.state.employeesFilter
                    : true
            )
            .filter((i) =>
                this.state.causeFilter && this.state.causeFilter !== 0
                    ? i.cause === this.state.causeFilter.toString()
                    : true
            )
            .filter((i) =>
                this.state.maatregelFilter && this.state.maatregelFilter !== 0
                    ? this.state.maatregelFilter === 1
                        ? i.maatregelen && i.maatregelen.length > 0
                        : i.maatregelen == null || i.maatregelen.length === 0
                    : true
            )
            .filter((i) =>
                this.state.situatieFilter && this.state.situatieFilter !== 0
                    ? this.state.situatieFilter === 1
                        ? !i.remark.unsafe
                        : i.remark.unsafe
                    : true
            ).sort( (a,b) => {
                if (a.date < b.date) return -1;
                if (a.date > b.date) return 1;
                return 0;
            });

        if (this.props.periodType === 'year') {
            incidents = incidents.filter(
                (i) => moment(i.date).year() === this.props.periodYear
            );
        } else if (this.props.periodType === 'month') {
            incidents = incidents
                .filter((i) => moment(i.date).year() === this.props.periodYear)
                .filter(
                    (i) => moment(i.date).month() === this.props.periodMonth
                );
        } else if (this.props.periodType === 'week') {
            incidents = incidents
                .filter((i) => moment(i.date).year() === this.props.periodYear)
                .filter((i) => moment(i.date).week() === this.props.periodWeek);
        } else if (this.props.periodType === 'fromtill') {
            incidents = incidents.filter(
                (i) =>
                    moment(i.date) > moment(this.props.periodFrom) &&
                    moment(i.date) < this.props.periodTill
            );
        }

        let data = [];

        incidents.forEach((item) => {
            data.push({
                date: moment(item.date).format('L HH:mm'),
                type:
                    item.type && this.props.incidenttype
                        ? t(
                              this.props.incidenttype.byId[item.type].locKey ||
                                  this.props.incidenttype.byId[item.type].name
                          )
                        : '',
                user: {
                    fullname: item.anonymous ? t("anonymous") : item.user.fullname,
                },
                cause:
                    item.cause && this.props.incidentcause
                        ? t(
                              this.props.incidentcause.byId[item.cause]
                                  .locKey ||
                                  this.props.incidentcause.byId[item.cause].name
                          )
                        : '',
                text: item.remark.text,
                bijlagen: item.remark.photos.length,
                maatregelen: item.maatregelen,
                situatie: item.remark.unsafe ? t('Unsafe situation') : '',
                causecomment: item.cause_comment,
                slachtoffer: item.slachtoffer,
                address: item.address,
                resolved: item.kamResolved ? t('Yes') : t('No'),
                comment: item.kamComment,
            });
        });

        fetchCSV({
            platform: 'VV',
            customer: 'VV',
            template: 'INCIDENT',
            options: {},
            data: data,
            info: {},
        })
            .then((res) => {
                const url = URL.createObjectURL(res.body);
                const link = document.createElement('a');
                link.setAttribute('href', url);
                link.setAttribute('download', 'registratiemeldingen.csv');
                link.click();
            })
            .catch((err) => console.log(err));
    };

    setPage = (page) => {
        // Store page in state
        this.setState({ page: page });
    }
    setRowsPerPage = (rowsPerPage) => {
        // Store rowsPerPage in state
        this.setState({ rowsPerPage: rowsPerPage });
    }


    combineDateAndTime = (date, time) => {
        let momentDate = moment(date);
        let momentTime = moment(time);

        const hours = momentTime.hours();
        const minutes = momentTime.minutes();

        var year = momentDate.year();
        var month = momentDate.month();
        var day = momentDate.date();
        var combined = moment()
            .year(year)
            .month(month)
            .date(day)
            .hours(hours)
            .minutes(minutes);

        return new Date(combined.valueOf());
    };

    handleDateChange = (event, date) => {
        this.refs.timepicker.openDialog();
        this.setState({ incident: { ...this.state.incident, date: date } });
    };

    handleTimeChange = (event, time) => {
        const datetime = this.combineDateAndTime(
            this.state.incident.date,
            time
        );
        this.setState({ incident: { ...this.state.incident, date: datetime } });
    };

    editIncident = (key) => (event) => {
        if (key === 'slachtoffer') {
            this.setState({
                incident: {
                    ...this.state.incident,
                    slachtoffer: event.target.value,
                },
            });
        } else if (key === 'remark') {
            this.setState({
                incident: {
                    ...this.state.incident,
                    remark: {
                        ...this.state.incident.remark,
                        text: event.target.value,
                    },
                },
            });
        } else if (key === 'cause-comment') {
            this.setState({
                incident: {
                    ...this.state.incident,
                    cause_comment: event.target.value,
                },
            });
        } else if (key === 'maatregelen') {
            this.setState({
                incident: {
                    ...this.state.incident,
                    maatregelen: event.target.value,
                },
            });
        } else if (key === 'unsafe') {
            this.setState({
                incident: {
                    ...this.state.incident,
                    remark: {
                        ...this.state.incident.remark,
                        unsafe: !this.state.incident.remark.unsafe,
                    },
                },
            });
        } else if (key === 'type') {
            this.setState({
                incident: { ...this.state.incident, type: event.target.value },
            });
        } else if (key === 'cause') {
            this.setState({
                incident: { ...this.state.incident, cause: event.target.value },
            });
        } else if (key === 'resolvedByKam') {
            this.setState({
                incident: {
                    ...this.state.incident,
                    kamResolved: !this.state.incident.kamResolved
                },
            });
        } else if (key === 'kam-comment') {
            this.setState({
                incident: { ...this.state.incident,kamComment: event.target.value },
            });
        }
    };

    componentWillMount() {
        const { t } = this.props;
        this.props.setViewkey();
        this.props.setCrumbPath();
        this.props.fetchIncidents();
        this.props.fetchIncidentTypes();
        this.props.fetchIncidentCause();

        let actions = [];

        actions.push({ id: 'edit', label: t('Change') });
        actions.push({ id: 'markResolved', label: t('Mark as done') });
        // TODO: Enable when ready actions.push({ id: 'getPDF', label: t('Download PDF file') });
        actions.push({ id: 'delete', label: t('Delete') });

        this.setState({ actions });
    }

    handleImageUpload = (event) => {
        if (event.id !== undefined) {
            this.setState({
                incident: {
                    ...this.state.incident,
                    remark: {
                        ...this.state.incident.remark,
                        photos: [
                            ...this.state.incident.remark.photos,
                            { id: event.id, url: event.url, photo: event.id },
                        ],
                    },
                },
            });
        }
    };

    handleRemoveImage = (id) => {
        if (this.state.incident.remark.photos) {
            let photos = this.state.incident.remark.photos;
            let newPhotos = [];

            photos.forEach((photo, index) => {
                if (index !== id) {
                    newPhotos.push(photos[index]);
                }
            });

            this.setState({
                incident: {
                    ...this.state.incident,
                    remark: {
                        ...this.state.incident.remark,
                        photos: newPhotos,
                    },
                },
            });
        }
    };

    render() {
        const { loading, t } = this.props;
        const { actions, columns, showResolveDialog } = this.state;

        let incidents = [];
        this.props.incidents &&
            this.props.incidents.allIds &&
            this.props.incidents.allIds.forEach((id) => {
                incidents.push(this.props.incidents.byId[id]);

                if (!users.includes(this.props.incidents.byId[id].user.id)) {
                    users.push(this.props.incidents.byId[id].user.id);
                }
            });

        incidents = incidents
            .filter((i) =>
                this.state.typeFilter && this.state.typeFilter !== 0
                    ? i.type === this.state.typeFilter.toString()
                    : true
            )
            .filter((i) =>
                this.state.employeesFilter && this.state.employeesFilter !== 0
                    ? i.user.id === this.state.employeesFilter
                    : true
            )
            .filter((i) =>
                this.state.causeFilter && this.state.causeFilter !== 0
                    ? i.cause === this.state.causeFilter.toString()
                    : true
            )
            .filter((i) =>
                this.state.maatregelFilter && this.state.maatregelFilter !== 0
                    ? this.state.maatregelFilter === 1
                        ? i.maatregelen && i.maatregelen.length > 0
                        : i.maatregelen == null || i.maatregelen.length === 0
                    : true
            )
            .filter((i) =>
                this.state.situatieFilter && this.state.situatieFilter !== 0
                    ? this.state.situatieFilter === 1
                        ? !i.remark.unsafe
                        : i.remark.unsafe
                    : true
            );

        if (this.props.periodType === 'year') {
            incidents = incidents.filter(
                (i) => moment(i.date).year() === this.props.periodYear
            );
        } else if (this.props.periodType === 'month') {
            incidents = incidents
                .filter((i) => moment(i.date).year() === this.props.periodYear)
                .filter(
                    (i) => moment(i.date).month() === this.props.periodMonth
                );
        } else if (this.props.periodType === 'week') {
            incidents = incidents
                .filter((i) => moment(i.date).year() === this.props.periodYear)
                .filter((i) => moment(i.date).week() === this.props.periodWeek);
        } else if (this.props.periodType === 'fromtill') {
            incidents = incidents.filter(
                (i) =>
                    moment(i.date) > moment(this.props.periodFrom) &&
                    moment(i.date) < this.props.periodTill
            );
        }

        const searchresults = incidents;


        const tableActionHeader = (
            <TableActionHeader title={this.getFilterBar()} />
        );

        return (
            <div>
                <Dialog
                    onClose={() => {
                        this.setState({ showResolveDialog: false });
                    }}
                    open={showResolveDialog}
                >
                    <DialogTitle>{t('Mark as done')}</DialogTitle>
                    <DialogContent>
                        <InputLabel htmlFor="wpi-kam-comment">
                            {t('Enter KAM Comment')}
                        </InputLabel>
                        <Input
                            fullWidth={true}
                            
                            id="kamComment"
                            value={ this.state.incidentToResolveComment}
                            onChange={this.editKamStatus('kamComment')}
                            multiline

                        />
                        <p style={{ marginBottom: '-12px' }}>
                            {t('Resolved by KAM?')}{' '}
                            <div
                                style={{
                                    float: 'right',
                                    marginTop: '-12px',
                                    marginRight: '50px',
                                }}
                            >
                                <Switch
                                    checked={ this.state.incidentToResolveSwitch }
                                    onChange={this.editKamStatus('kamSwitch')}
                                    id="kamSwitch"
                                />
                            </div>
                        </p>


                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={ this.editKamStatus('kamSave')}
                        >
                            {t('Save')}
                        </Button>
                        <Button
                            onClick={() => {
                                this.setState({ showResolveDialog: false });
                            }}
                        >
                            {t('Cancel')}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={this.state.openWarning}
                    onClose={() => this.setState({ openWarning: false })}
                >
                    <DialogTitle className="title">
                        {t('Not all mandatory fields completed')}
                    </DialogTitle>
                    <DialogContent>
                        {t('Fill all fields and send again')}
                    </DialogContent>
                    <div className="confirmButton-container">
                        <Button
                             
                            className="confirmButton"
                            onClick={() =>
                                this.setState({ openWarning: false })
                            }
                        >
                            {t('Ok')}
                        </Button>
                    </div>
                </Dialog>
                <ConfirmDialog
                    open={this.state.showDeleteDialog}
                    handleClose={this.hideDeleteDialog}
                    deleteincident={this.state.incidentToDelete}
                    deleteIncidentFunction={this.deleteIncident}
                />
                <Drawer
                    anchor="right"
                    open={this.state.incidentOpen}
                    onClose={this.toggleDrawer}
                    style={{ zIndex: 1102 }}
                >
                    <div tabIndex={0} role="button">
                        {!this.state.editMode ? (
                            <div style={{ width: '600px' }}>
                                <div>
                                    <p
                                        style={{
                                            fontSize: '20px',
                                            marginLeft: '24px',
                                            float: 'left',
                                        }}
                                    >
                                        {this.state.incident
                                            ? moment(
                                                  this.state.incident.date
                                              ).format('LLL') +
                                              ', ' +
                                              (this.state.incident.anonymous ? t('anonymous') : this.state.incident.user.fullname)
                                            : '-'}
                                    </p>
                                    <IconButton
                                        style={{
                                            float: 'right',
                                            marginTop: '10px',
                                        }}
                                        onClick={this.toggleDrawer}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </div>
                                <Divider style={{ width: '100%' }} />

                                <Button
                                    onClick={this.editMode}
                                    style={{
                                        color: '#0076FF',
                                        float: 'right',
                                        marginRight: '24px',
                                        marginTop: '10px',
                                    }}
                                >
                                    {t('Change data')}
                                </Button>

                                <div
                                    style={{
                                        marginLeft: '24px',
                                        marginTop: '76px',
                                    }}
                                >
                                    <p style={{ marginBottom: '-4px' }}>
                                        <b>{t('Notification details')}</b>
                                    </p>
                                    <TitleDescription
                                        className={classes.item}
                                        itemTitle={t('Type of report')}
                                        itemDescription={
                                            this.state.incident &&
                                            this.state.incident.type &&
                                            this.props.incidenttype
                                                ? t(
                                                      this.props.incidenttype
                                                          .byId[
                                                          this.state.incident
                                                              .type
                                                      ].locKey ||
                                                          this.props
                                                              .incidenttype
                                                              .byId[
                                                              this.state
                                                                  .incident.type
                                                          ].name
                                                  )
                                                : '-'
                                        }
                                    />
                                    <TitleDescription
                                        className={classes.item}
                                        itemTitle={`${t('Victim')} / ${t(
                                            'Affected'
                                        )} / ${t('Customer')}`}
                                        itemDescription={
                                            this.state.incident &&
                                            this.state.incident.slachtoffer
                                                ? this.state.incident
                                                      .slachtoffer
                                                : '-'
                                        }
                                        width={'250px'}
                                    />
                                    <TitleDescription
                                        className={classes.item2}
                                        itemTitle={t('Description')}
                                        itemDescription={
                                            this.state.incident &&
                                            this.state.incident.remark.text
                                                ? this.state.incident.remark
                                                      .text
                                                : '-'
                                        }
                                    />
                                </div>

                                <div
                                    style={{
                                        marginLeft: '24px',
                                        marginTop: '76px',
                                    }}
                                >
                                    <p style={{ marginBottom: '-4px' }}>
                                        <b>{t('Cause details')}</b>
                                    </p>
                                    <TitleDescription
                                        className={classes.item2}
                                        itemTitle={t('Type of cause')}
                                        itemDescription={
                                            this.state.incident &&
                                            this.state.incident.cause &&
                                            this.props.incidentcause
                                                ? t(
                                                      this.props.incidentcause
                                                          .byId[
                                                          this.state.incident
                                                              .cause
                                                      ].locKey ||
                                                          this.props
                                                              .incidentcause
                                                              .byId[
                                                              this.state
                                                                  .incident
                                                                  .cause
                                                          ].name
                                                  )
                                                : '-'
                                        }
                                    />
                                    <TitleDescription
                                        className={classes.item2}
                                        itemTitle={t('Explanation of cause')}
                                        itemDescription={
                                            this.state.incident &&
                                            this.state.incident.cause_comment
                                                ? this.state.incident
                                                      .cause_comment
                                                : '-'
                                        }
                                    />
                                </div>

                                <div
                                    style={{
                                        marginLeft: '24px',
                                        marginTop: '76px',
                                    }}
                                >
                                    <p style={{ marginBottom: '-4px' }}>
                                        <b>{t('Action taken immediately')}</b>
                                    </p>
                                    <TitleDescription
                                        className={classes.item2}
                                        itemTitle={t('Measure')}
                                        itemDescription={
                                            this.state.incident &&
                                            this.state.incident.maatregelen
                                                ? this.state.incident
                                                      .maatregelen
                                                : '-'
                                        }
                                    />
                                </div>

                                <div
                                    style={{
                                        marginLeft: '24px',
                                        marginTop: '76px',
                                    }}
                                >
                                    <p style={{ marginBottom: '-4px' }}>
                                        <b>{t('Situation')}</b>
                                    </p>
                                    <TitleDescription
                                        className={classes.item}
                                        itemTitle={t('Is situation unsave?')}
                                        itemDescription={
                                            this.state.incident &&
                                            this.state.incident.remark.unsafe
                                                ? t('Yes')
                                                : t('No')
                                        }
                                    />
                                    {this.state.incident &&
                                        this.state.incident.remark.unsafe && (
                                            <div
                                                className={'border-text'}
                                                style={{
                                                    backgroundColor: getColorForPercentage(
                                                        0
                                                    ),
                                                    borderColor: getColorForPercentage(
                                                        0
                                                    ),
                                                    width: '120px',
                                                    fontWeight: '300',
                                                    float: 'right',
                                                    marginTop: '20px',
                                                    marginRight: '30px',
                                                }}
                                            >
                                                <span>
                                                    <WarningIcon
                                                        style={{
                                                            width: '14px',
                                                            height: '14px',
                                                            position:
                                                                'relative',
                                                            top: '2px',
                                                            marginRight: '5px',
                                                        }}
                                                    />
                                                    {t('Unsafe situation')}
                                                </span>
                                            </div>
                                        )}
                                </div>

                                <div
                                    style={{
                                        marginLeft: '24px',
                                        marginTop: '76px',
                                    }}
                                >
                                    <p style={{ marginBottom: '-4px' }}>
                                        <b>{t('Location')}</b>
                                    </p>
                                    <TitleDescription
                                        className={classes.item2}
                                        itemTitle={t('Location')}
                                        itemDescription={
                                            this.state.incident &&
                                            this.state.incident.address
                                                ? this.state.incident.address
                                                : '-'
                                        }
                                    />
                                </div>

                                <div
                                    style={{
                                        marginLeft: '24px',
                                        marginTop: '76px',
                                    }}
                                >
                                    <p style={{ marginBottom: '-4px' }}>
                                        <b>{t('Attachments')}</b>
                                    </p>
                                    <TitleDescription
                                        className={classes.item2}
                                        itemTitle={t('Images')}
                                        itemDescription={
                                            this.state.incident &&
                                            this.state.incident.remark.photos
                                                .length > 0
                                                ? ''
                                                : '-'
                                        }
                                    />
                                    {this.state.incident &&
                                        this.state.incident.remark.photos
                                            .length > 0 && (
                                            <div
                                                style={{
                                                    maxWidth: '550px',
                                                    marginTop: '16px',
                                                }}
                                            >
                                                {this.state.incident &&
                                                    this.state.incident.remark.photos.map(
                                                        (photo) => {
                                                            return (
                                                                <img
                                                                    src={
                                                                        photo.url
                                                                    }
                                                                    alt=""
                                                                    style={{
                                                                        width:
                                                                            '64px',
                                                                        height:
                                                                            '64px',
                                                                        marginRight:
                                                                            '8px',
                                                                        marginBottom:
                                                                            '8px',
                                                                        borderRadius:
                                                                            '8px',
                                                                    }}
                                                                    onClick={() => {
                                                                        this.setState(
                                                                            {
                                                                                imageVisible: true,
                                                                                activePhotoId:
                                                                                    photo.id,
                                                                            }
                                                                        );
                                                                    }}
                                                                />
                                                            );
                                                        }
                                                    )}
                                            </div>
                                        )}
                                </div>

                                <div
                                    style={{
                                        marginLeft: '24px',
                                        marginTop: '76px',
                                        marginBottom: '24px',
                                    }}
                                >
                                    <p style={{ marginBottom: '-4px' }}>
                                        <b>{t('KAM Comment')}</b>
                                    </p>
                                    <p>
                                        {this.state.incident ? this.state.incident.kamComment : '-'}
                                    </p>
                                    <TitleDescription
                                        className={classes.item}
                                        itemTitle={t('Resolved by KAM?')}
                                        itemDescription={
                                            this.state.incident &&
                                            this.state.incident.kamResolved
                                                ? t('Yes')
                                                : t('No')
                                        }
                                    />

                                </div>


                            </div>
                        ) : (
                            <div style={{ width: '600px' }}>
                                <div>
                                    <p
                                        style={{
                                            fontSize: '20px',
                                            marginLeft: '24px',
                                            float: 'left',
                                        }}
                                    >
                                        {this.state.incident
                                            ? moment(
                                                  this.state.incident.date
                                              ).format('LLL') +
                                              ', ' +
                                              this.state.incident.user
                                                  .fullname +
                                              ' (' +
                                              t('Edit') +
                                              ')'
                                            : '-'}
                                    </p>
                                    <IconButton
                                        style={{
                                            float: 'right',
                                            marginTop: '10px',
                                        }}
                                        onClick={this.toggleDrawer}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </div>
                                <Divider style={{ width: '100%' }} />

                                <div
                                    style={{
                                        height: '56px',
                                        backgroundColor: colors.primaryColor,
                                    }}
                                >
                                    <Button
                                        onClick={this.deleteIncidentDialog}
                                        style={{
                                            color: '#FF001F',
                                            marginLeft: '24px',
                                            marginTop: '10px',
                                            float: 'left',
                                        }}
                                    >
                                        {t('Delete')}
                                    </Button>

                                    <Button
                                        onClick={this.save}
                                        style={{
                                            color: '#0076FF',
                                            float: 'right',
                                            marginRight: '24px',
                                            marginTop: '10px',
                                        }}
                                    >
                                        {t('Save')}
                                    </Button>

                                    <Button
                                        onClick={this.cancelEditMode}
                                        style={{
                                            color: '#0076FF',
                                            float: 'right',
                                            marginRight: '12px',
                                            marginTop: '10px',
                                        }}
                                    >
                                        {t('Cancel')}
                                    </Button>
                                </div>

                                <div
                                    style={{
                                        marginLeft: '24px',
                                        marginTop: '76px',
                                    }}
                                >
                                    <p style={{ marginBottom: '-4px' }}>
                                        <b>{t('Notification details')}</b>
                                    </p>
                                    <FormControl
                                        className={classes.item}
                                        style={{ width: '230px' }}
                                    >
                                        <InputLabel>
                                            {t('Type of report')}*
                                        </InputLabel>
                                        <Select
                                            variant="standard"
                                            value={
                                                this.state.incident &&
                                                this.state.incident.type
                                                    ? this.state.incident.type
                                                    : ''
                                            }
                                            onChange={this.editIncident('type')}
                                        >
                                            {this.props.incidenttype &&
                                                this.props.incidenttype.allIds.map(
                                                    (type) => {
                                                        return (
                                                            <MenuItem
                                                                key={this.props.incidenttype.byId[type].id}
                                                                value={
                                                                    this.props.incidenttype.byId[type].id}
                                                            >
                                                                <ListItemText
                                                                    primary={t(this.props.incidenttype.byId[type].locKey ||
                                                                            this.props.incidenttype.byId[type].name
                                                                    )}
                                                                />
                                                            </MenuItem>
                                                        );
                                                    }
                                                )}
                                        </Select>
                                    </FormControl>
                                    <FormControl
                                        className={classes.item}
                                        style={{
                                            width: '230px',
                                            marginLeft: '45px',
                                        }}
                                    >
                                        <InputLabel htmlFor="incident-slachtoffer">
                                            {t('Victim')} / {t('Affected')} /{' '}
                                            {t('Customer')}
                                        </InputLabel>
                                        <Input
                                            fullWidth={true}
                                            
                                            id="incident-slachtoffer"
                                            value={
                                                this.state.incident &&
                                                this.state.incident.slachtoffer
                                                    ? this.state.incident
                                                          .slachtoffer
                                                    : ''
                                            }
                                            onChange={this.editIncident('slachtoffer')}
                                        />
                                    </FormControl>
                                    <FormControl
                                        className={classes.item2}
                                        style={{ width: '505px' }}
                                    >
                                        <InputLabel htmlFor="incident-description">
                                            {t('Description')}*
                                        </InputLabel>
                                        <Input
                                            fullWidth={true}
                                            
                                            id="incident-description"
                                            value={
                                                this.state.incident &&
                                                this.state.incident.remark.text
                                                    ? this.state.incident.remark
                                                          .text
                                                    : ''
                                            }
                                            onChange={this.editIncident(
                                                'remark'
                                            )}
                                            multiline
                                        />
                                    </FormControl>
                                </div>

                                <div
                                    style={{
                                        marginLeft: '24px',
                                        marginTop: '76px',
                                    }}
                                >
                                    <p style={{ marginBottom: '-4px' }}>
                                        <b>{t('Cause details')}</b>
                                    </p>
                                    <FormControl
                                        className={classes.item}
                                        style={{ width: '230px' }}
                                    >
                                        <InputLabel>
                                            {t('Type of cause')}*
                                        </InputLabel>
                                        <Select
                                            variant="standard"
                                            value={
                                                this.state.incident &&
                                                this.state.incident.cause
                                                    ? this.state.incident.cause
                                                    : ''
                                            }
                                            onChange={this.editIncident(
                                                'cause'
                                            )}
                                        >
                                            {this.props.incidentcause &&
                                                this.props.incidentcause.allIds.map(
                                                    (cause) => {
                                                        return (
                                                            <MenuItem
                                                                key={
                                                                    this.props
                                                                        .incidentcause
                                                                        .byId[
                                                                        cause
                                                                    ].id
                                                                }
                                                                value={
                                                                    this.props
                                                                        .incidentcause
                                                                        .byId[
                                                                        cause
                                                                    ].id
                                                                }
                                                            >
                                                                <ListItemText
                                                                    primary={t(
                                                                        this
                                                                            .props
                                                                            .incidentcause
                                                                            .byId[
                                                                            cause
                                                                        ]
                                                                            .locKey ||
                                                                            this
                                                                                .props
                                                                                .incidentcause
                                                                                .byId[
                                                                                cause
                                                                            ]
                                                                                .locKey
                                                                                .name
                                                                    )}
                                                                />
                                                            </MenuItem>
                                                        );
                                                    }
                                                )}
                                        </Select>
                                    </FormControl>
                                    <FormControl
                                        className={classes.item2}
                                        style={{ width: '505px' }}
                                    >
                                        <InputLabel htmlFor="incident-cause-comment">
                                            {t('Enter explanation cause')}*
                                        </InputLabel>
                                        <Input
                                            fullWidth={true}
                                            
                                            id="incident-cause-comment"
                                            value={
                                                this.state.incident &&
                                                this.state.incident
                                                    .cause_comment
                                                    ? this.state.incident
                                                          .cause_comment
                                                    : ''
                                            }
                                            onChange={this.editIncident(
                                                'cause-comment'
                                            )}
                                            multiline
                                        />
                                    </FormControl>
                                </div>

                                <div
                                    style={{
                                        marginLeft: '24px',
                                        marginTop: '76px',
                                    }}
                                >
                                    <p style={{ marginBottom: '-4px' }}>
                                        <b>{t('Action taken immediately')}</b>
                                    </p>
                                    <FormControl
                                        className={classes.item2}
                                        style={{ width: '505px' }}
                                    >
                                        <InputLabel htmlFor="incident-maatregel">
                                            {t('Measures')}
                                        </InputLabel>
                                        <Input
                                            fullWidth={true}
                                            
                                            id="incident-maatregel"
                                            value={
                                                this.state.incident &&
                                                this.state.incident.maatregelen
                                                    ? this.state.incident
                                                          .maatregelen
                                                    : ''
                                            }
                                            onChange={this.editIncident(
                                                'maatregelen'
                                            )}
                                            multiline
                                        />
                                    </FormControl>
                                </div>

                                <div
                                    style={{
                                        marginLeft: '24px',
                                        marginTop: '76px',
                                    }}
                                >
                                    <p style={{ marginBottom: '-4px' }}>
                                        <b>{t('Situation')}</b>
                                    </p>
                                    <p style={{ marginBottom: '-4px' }}>
                                        {t('Is situation unsave?')}{' '}
                                        <div
                                            style={{
                                                float: 'right',
                                                marginTop: '-20px',
                                                marginRight: '50px',
                                            }}
                                        >
                                            <Switch
                                                checked={
                                                    this.state.incident &&
                                                    this.state.incident.remark
                                                        .unsafe
                                                }
                                                onChange={this.editIncident(
                                                    'unsafe'
                                                )}
                                                id="unsafe"
                                            />
                                        </div>
                                    </p>
                                </div>

                                <div
                                    style={{
                                        marginLeft: '24px',
                                        marginTop: '76px',
                                    }}
                                >
                                    <p style={{ marginBottom: '-4px' }}>
                                        <b>{t('Attachments')}</b>
                                    </p>
                                    <TitleDescription
                                        className={classes.item2}
                                        itemTitle={t('Photos')}
                                        itemDescription={
                                            this.state.incident &&
                                            this.state.incident.remark.photos
                                                .length > 0
                                                ? ''
                                                : '-'
                                        }
                                    />
                                    {this.state.incident &&
                                        this.state.incident.remark.photos
                                            .length > 0 && (
                                            <div
                                                style={{
                                                    maxWidth: '550px',
                                                    marginTop: '16px',
                                                }}
                                            >
                                                <p style={{fontSize: '16px'}}><b>{'Foto(s) toevoegen'}</b></p>
                                                {(!loading) && <div style={{display: 'inline-block'}}>
                                                    <div style={{float: 'left', marginRight: '10px', marginTop: '10px', position: 'relative'}}><SimpleImageInput id={'incidentphoto0'} onChange={this.handleImageUpload} url={(this.state.incident && this.state.incident.remark.photos[0]) ? this.state.incident.remark.photos[0].url : ''} />
                                                        {(this.state.incident && this.state.incident.remark.photos[0]) && <IconButton   className="drawer-button" onClick={() => this.handleRemoveImage(0)} style={{position: 'absolute', bottom: '-5px', right: '-20px'}}>
                                                            <DeleteIcon className="drawer-icon" />
                                                        </IconButton>}</div>
                                                    {this.state.incident && this.state.incident.remark.photos[0] && <div style={{float: 'left', marginRight: '10px', marginTop: '10px', position: 'relative'}}><SimpleImageInput id={'incidentphoto1'} onChange={this.handleImageUpload} disabled={false} url={(this.state.incident && this.state.incident.remark.photos[1]) ? this.state.incident.remark.photos[1].url : ''} />
                                                        {(this.state.incident && this.state.incident.remark.photos[1]) && <IconButton   className="drawer-button" onClick={() => this.handleRemoveImage(1)} style={{position: 'absolute', bottom: '-5px', right: '-20px'}}>
                                                            <DeleteIcon className="drawer-icon" />
                                                        </IconButton>}</div>}
                                                    {this.state.incident && this.state.incident.remark.photos[1] && <div style={{float: 'left', marginRight: '10px', marginTop: '10px', position: 'relative'}}><SimpleImageInput id={'incidentphoto2'} onChange={this.handleImageUpload} url={(this.state.incident && this.state.incident.remark.photos[2]) ? this.state.incident.remark.photos[2].url : ''} />
                                                        {(this.state.incident && this.state.incident.remark.photos[2]) && <IconButton   className="drawer-button" onClick={() => this.handleRemoveImage(2)} style={{position: 'absolute', bottom: '-5px', right: '-20px'}}>
                                                            <DeleteIcon className="drawer-icon" />
                                                        </IconButton>}</div>}
                                                    {this.state.incident && this.state.incident.remark.photos[2] && <div style={{float: 'left', marginRight: '10px', marginTop: '10px', position: 'relative'}}><SimpleImageInput id={'incidentphoto3'} onChange={this.handleImageUpload} url={(this.state.incident && this.state.incident.remark.photos[3]) ? this.state.incident.remark.photos[3].url : ''} />
                                                        {(this.state.incident && this.state.incident.remark.photos[3]) && <IconButton   className="drawer-button" onClick={() => this.handleRemoveImage(3)} style={{position: 'absolute', bottom: '-5px', right: '-20px'}}>
                                                            <DeleteIcon className="drawer-icon" />
                                                        </IconButton>}</div>}
                                                    {this.state.incident && this.state.incident.remark.photos[3] && <div style={{float: 'left', marginRight: '10px', marginTop: '10px', position: 'relative'}}><SimpleImageInput id={'incidentphoto4'} onChange={this.handleImageUpload} url={(this.state.incident && this.state.incident.remark.photos[4]) ? this.state.incident.remark.photos[4].url : ''} />
                                                        {(this.state.incident && this.state.incident.remark.photos[4]) && <IconButton   className="drawer-button" onClick={() => this.handleRemoveImage(4)} style={{position: 'absolute', bottom: '-5px', right: '-20px'}}>
                                                            <DeleteIcon className="drawer-icon" />
                                                        </IconButton>}</div>}
                                                </div>}
                                                {this.props.incident && this.props.incident.remark.photos.map(photo => <img style={{float: 'left', marginRight: '10px', marginTop: '10px'}} src={photo.url} alt={'foto'} width="128px" height="128px"/>) }
                                                <br/>

                                            </div>
                                        )}
                                </div>

                                <div
                                    style={{
                                        marginLeft: '24px',
                                        marginTop: '76px',
                                    }}
                                >
                                    <p style={{ marginBottom: '-4px' }}>
                                        <b>{t('KAM Status')}</b>
                                    </p>
                                    <p style={{ marginBottom: '-4px' }}>
                                        {t('Resolved by KAM?')}{' '}
                                        <div
                                            style={{
                                                float: 'right',
                                                marginTop: '-20px',
                                                marginRight: '50px',
                                            }}
                                        >
                                            <Switch
                                                checked={
                                                    this.state.incident &&
                                                    this.state.incident.kamResolved
                                                }
                                                onChange={this.editIncident(
                                                    'resolvedByKam'
                                                )}
                                                id="resolvedByKam"
                                            />
                                        </div>
                                    </p>
                                </div>

                                <div
                                    style={{
                                        marginLeft: '24px',
                                        marginTop: '24px',
                                        marginBottom: '24px',
                                    }}
                                >
                                    <FormControl
                                        className={classes.item2}
                                        style={{ width: '505px' }}
                                    >
                                        <InputLabel htmlFor="incident-cause-comment">
                                            {t('Enter KAM Comment')}
                                        </InputLabel>
                                        <Input
                                            fullWidth={true}
                                            
                                            id="kam-comment"
                                            value={
                                                this.state.incident &&
                                                this.state.incident.kamComment
                                                    ? this.state.incident.kamComment
                                                    : ''
                                            }
                                            onChange={this.editIncident(
                                                'kam-comment'
                                            )}
                                            multiline
                                                />
                                    </FormControl>

                                </div>


                            </div>
                        )}
                    </div>
                </Drawer>
                <AppModule loading={loading} prepend={tableActionHeader}>
                    <EnhancedTable
                        hover
                        defaultOrderBy={'date'}
                        defaultOrder="desc"
                        columns={columns}
                        onClick={this.onRowClick}
                        rows={searchresults}
                        formatter={this.mapIncidentToRow}
                        actions={actions}
                        onAction={this.handleAction}
                        sorter={this.incidentSorter()}
                        emptyState={
                            this.state.searchtext.length > 0
                                ? t('No searchresults')
                                : t('No reports yet')
                        }
                        onPageChange={this.setPage}
                        onRowsPerPageChange={this.setRowsPerPage}

                    />
                </AppModule>
                <div
                    style={{
                        position: 'fixed',
                        top: '32px',
                        right: '36px',
                        zIndex: 1101,
                    }}
                >
                    <div>
                        <Fab   onClick={this.toggleExport}>
                            {this.state && this.state.exportOpen ? (
                                <CloseIcon />
                            ) : (
                                <DownloadIcon />
                            )}
                        </Fab>
                    </div>
                    <div
                        style={
                            this.state && this.state.exportOpen
                                ? {
                                      marginTop: '15px',
                                      marginLeft: '8px',
                                      visibility: 'visible',
                                      transition: 'margin-top 300ms',
                                  }
                                : {
                                      marginTop: '0px',
                                      marginLeft: '8px',
                                      visibility: 'hidden',
                                      transition: 'margin-top 300ms',
                                  }
                        }
                        className={'tooltip'}
                    >
                        <span
                            className={
                                this.state && this.state.exportOpen
                                    ? 'tooltiptextvisible'
                                    : 'tooltiptext'
                            }
                            style={{ top: '87px', right: '60px' }}
                        >
                            {t('Download CSV file')}
                        </span>
                        <Fab
                            color="primary"
                            
                            onClick={this.downloadCsv}
                        >
                            <DescIcon />
                        </Fab>
                    </div>
                </div>
                {this.state.incident &&
                    this.state.incident.remark.photos.length > 0 && (
                        <Viewer
                            visible={this.state.imageVisible}
                            activeIndex={this.state.incident.remark.photos.findIndex(
                                (p) => p.id === this.state.activePhotoId
                            )}
                            drag={false}
                            scalable={false}
                            zIndex={2000}
                            downloadable={true}
                            onClose={() => {
                                this.setState({ imageVisible: false });
                            }}
                            onMaskClick={() => {
                                this.setState({ imageVisible: false });
                            }}
                            images={this.state.incident.remark.photos.map(
                                (photo) => {
                                    return {
                                        src: photo.url,
                                        downloadUrl: photo.url + '.jpg',
                                    };
                                }
                            )}
                        />
                    )}
            </div>
        );
    }
}

var percentColors = percentColors1;

var getColorForPercentage = function (pct) {
    let color = percentColors[0];

    if (pct === 0) {
        color = percentColors[0];
    }

    if (pct === 1) {
        color = percentColors[2];
    }

    return 'rgba(' + [color.r, color.g, color.b].join(',') + ', 1)';
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    
    withTranslation()
)(Incidents);
